<template>
  <div class="w-full px-6 py-4">
    <o-field-group
      v-for="tax in taxOptions"
      :key="tax.idTax"
      v-slot="{ status }"
      :label="tax.name"
      :name="tax.name"
      :info="$t('components.pass.edit.taxes.info', { name: tax.name, amount: tax.amountLabel })"
      class="mb-4 block"
      col
      reverse
    >
      <toggle-field v-model="_pass.taxIDs" :status="status" :value="Number(tax.idTax)" />
    </o-field-group>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import {
  ToggleField,
} from '@/components/fields'

interface Props {
  pass: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:pass', value: Record<string, any>): void
}>()

const _pass = computed({
  get () {
    return props.pass
  },
  set (value) {
    emit('update:pass', value)
  },
})

const taxOptions = computed(() => {
  return _pass.value.options.taxes
})
</script>
